<template>
  <div
    class="r-heading"
    :class="classes"
  >
    <div
      class="r-heading__title"
      :class="classes"
    >
      <kicker
        v-if="hasKicker"
        :color="kickerColor"
        :weight="kickerWeight"
        :align="align"
      >
        <slot name="kicker" />
      </kicker>
      <c-title
        :color="titleColor"
        :size="titleSize"
        :weight="titleWeight"
        :align="align"
      >
        <slot name="title" />
      </c-title>
    </div>
    <div
      v-if="hasButton || hasIcons"
      class="r-heading__buttons"
      :class="{ 'r-heading--icons': hasIcons }"
      @click="pushGTM"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import CTitle from '@atoms/title/title.vue'
import Kicker from '@atoms/kicker/kicker.vue'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'c-heading',
  components: { CTitle, Kicker },
  props: {
    hasKicker: {
      type: Boolean,
      default: false,
    },
    kickerColor: {
      type: String,
      default: '#717D96',
    },
    kickerWeight: {
      type: String,
      default: '700',
    },
    titleColor: {
      type: String,
    },
    titleSize: {
      type: String,
      default: 'h2',
    },
    titleWeight: {
      type: String,
      default: '400',
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'left',
    },
    isMobileGrid: {
      type: Boolean,
      default: false,
    },
    hasIcons: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const classes = computed(() => [
      `r-heading--${props.align}`,
      { 'r-heading--has-button': props.hasButton },
      { 'r-heading--grid': props.isMobileGrid },
    ])

    const pushGTM = (event) => {
      const target = event.target.closest('a')

      if (target) {
        window.dataLayer.push({
          event: 'click',
          section: 'vazio',
          outbound: isOutbound(target),
          label: target?.innerText || target?.getAttribute('aria-label') || ''
        })
      }
    }

    return {
      classes, pushGTM,
    }
  },
}
</script>

<style scoped lang="scss">
.r-heading {
  display: grid;
  align-items: center;
  gap: 1.5rem;
  width: -webkit-fill-available;

  &--grid {
    grid-template-columns: repeat(2, auto);
    align-items: center;
    justify-content: space-between !important;
  }

  @media screen and (min-width: 768px) {
    &.r-heading--has-button {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__title {
    &.r-heading--has-button {
      @media screen and (min-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;

    @media screen and (min-width: 768px) {
      margin-top: unset;
    }
  }

  &--left {
    text-align: start;
    justify-content: start;

    .r-heading__buttons {
      display: flex;
      justify-content: flex-start;

      @media screen and (min-width: 768px) {
        justify-content: flex-end;
      }
    }
  }

  &--center {
    text-align: center;
    justify-content: center;

    .r-heading__buttons {
      display: flex;
      justify-content: center;
    }
  }

  &--right {
    text-align: end;
    justify-content: end;

    .r-heading__buttons {
      display: flex;
      justify-content: flex-end;
    }
  }

  &--icons {
    display: flex;
    gap: 0.5rem;

    @media screen and (min-width: 768px) {
      gap: 1rem;
    }
  }
}
</style>
